/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Prioritization_TitleInputs */

const fr_help_prioritization_title = /** @type {(inputs: Help_Prioritization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorisation`)
};

const en_help_prioritization_title = /** @type {(inputs: Help_Prioritization_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioritization`)
};

/**
* | output |
* | --- |
* | "Prioritization" |
*
* @param {Help_Prioritization_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_prioritization_title = /** @type {((inputs?: Help_Prioritization_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Prioritization_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_prioritization_title(inputs)
	return en_help_prioritization_title(inputs)
});